<template>
    <button
            class="vue-button"
            @click="handleClick"
            :disabled="buttonDisabled || loading"
            :autofocus="autofocus"
            :type="nativeType"
            :class="[
      type ? 'vue-button_' + type : '',
      buttonSize ? 'vue-button_' + buttonSize : '',
      {
        'vue-button_is-disabled': buttonDisabled,
        'vue-button_is-loading': loading,
        'vue-button_is-plain': plain,
        'vue-button_is-round': round,
        'vue-button_is-circle': circle
      }
    ]"
    >
        <i class="vue-button__icon-loading fa fa-spinner fa-spin" v-if="loading"></i>
        <i class="vue-button__icon" :class="icon" v-if="icon && !loading"></i>
        <i class="vue-button__icon vue-button__icon_left" :class="icon_left" v-if="icon_left && !loading"></i>
        <span v-if="$slots.default" class="vue-button__title"><slot></slot></span>
        <i class="vue-button__icon vue-button__icon_right" :class="icon_right" v-if="icon_right && !loading"></i>
    </button>
</template>
<script>
    export default {
        name: 'vue-button',
        inject: {
            elForm: {
                default: ''
            },
            elFormItem: {
                default: ''
            }
        },
        props: {
            type: {
                type: String,
                default: 'default'
            },
            size: String,
            icon: {
                type: String,
                default: ''
            },
            icon_left: {
                type: String,
                default: ''
            },
            icon_right: {
                type: String,
                default: ''
            },
            nativeType: {
                type: String,
                default: 'button'
            },
            loading: Boolean,
            disabled: Boolean,
            plain: Boolean,
            autofocus: Boolean,
            round: Boolean,
            circle: Boolean
        },
        computed: {
            _elFormItemSize() {
                return (this.elFormItem || {}).elFormItemSize;
            },
            buttonSize() {
                return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
            },
            buttonDisabled() {
                return this.disabled || (this.elForm || {}).disabled;
            }
        },
        methods: {
            handleClick(evt) {
                this.$emit('click', evt);
            }
        }
    };
</script>
<style lang="scss">

</style>